import { VisitorID } from "./components/visitor-id.js";
import { getBrowserType } from "./core/utils.js";
import { checkNewTabButtonTarget } from "./components/cta-new-tab.js";
import { initCampaign } from "./components/journey-tracker.js";
import { form } from "./components/form.js";
import { waba } from "./components/waba-trigger.js";
import { checkChannelParams } from "./components/channel-params.js";
import { initCTAPartner } from "./components/cta-partner.js";
import { initWabaTracking } from "./components/utm-tracker.js";
import { initInquiryParallelSubmit } from "./components/inquiry-tracker.js";

(function ($) {
    "use strict";

    const visitorID = VisitorID.init();
    console.log('Current Visitor ID:', visitorID);

    function checkStickyWABA() {
        var stickyWABA = document.querySelector(".ic-wa");
        if (!stickyWABA) {
            var scrollTop = document.querySelector("#scroll-top");
            if (scrollTop) {
                scrollTop.classList.add("alt");
            }
        }
    }

    initWabaTracking({
        csv: {
            mediumUrl: document.querySelector("#medium_file")?.value || "",
            campaignUrl: document.querySelector("#campaign_file")?.value || "",
        },
        ttlDays: 31,
        debug: false,
        channelCodes: {
            medium: { "organic direct": "O6A", "organic search": "O5A" },
            campaign: { default: "MO" },
        },
    }).then(({ code, ccode, updated, source }) => {
        checkStickyWABA();
        getBrowserType();
        checkNewTabButtonTarget();
        waba();
        initCampaign(() => form());
        checkChannelParams();
        // form();
        initCTAPartner();
        initInquiryParallelSubmit({
            formSelector: 'form[data-inquiry-tracking="true"]',
            scriptURL:
                "https://script.google.com/macros/s/AKfycbx7Kuq-HW-DhQHQu45CErX6QlrNe9_EO0AIQlQEXONqJyL_8T-ohYdRDD_PJyVKJCtYuA/exec",
            buttonSelectors: ["#submit-inquiry-form", ".btn-submit"],
        });
    });
})(jQuery);
